import { render, staticRenderFns } from "./NewPrefill.vue?vue&type=template&id=63aeb6ed&"
import script from "./NewPrefill.vue?vue&type=script&lang=js&"
export * from "./NewPrefill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports